
import { FC, lazy } from "react";
import { Content } from "_metronic/layout/components/Content";
const RetailerCountStats = lazy(() => import('./dashboards/retailer-count-stats'))
const SupplierCountStats = lazy(() => import('./dashboards/supplier-count-stats'))
const LastFiveAccounts = lazy(() => import('./dashboards/last-five-accounts'))

const AdminHome: FC = () => {
    return (

        <Content>
            {/* begin::Row */}
            <div className='row g-5 g-xl-8'>
                {/* begin::Col */}
                <div className='col-xl-6'>
                    <LastFiveAccounts className='clard-x-stretch mb-5 mb-xl-8' />
                </div>

                <div className='col-xl-2'>
                    <RetailerCountStats
                        className='card-xxl-4 mb-5 mb-xl-8 bg-dark '
                        svgIcon='parcel'
                        titleClass='text-white'
                        descriptionClass='text-white'
                        iconClass='text-white'
                    />
                    <SupplierCountStats
                        className='card-xxl-4 mb-5 mb-xl-8 bg-success'
                        svgIcon='parcel'
                        titleClass='text-white'
                        descriptionClass='text-white'
                        iconClass='text-white'
                    />
                </div>
                {/* end::Col */}
            </div>
            {/* end::Row */}

        </Content>

    )
}
export default AdminHome; 